/* © ИП Коробкин И.Н., KIN DIGITAL CRM+ */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Search } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Badge, Button, ErrorText, Input, PageHeader, Spinner } from '@/components/ui';
import { api } from '@/lib/api';
import { useAuth } from '@/lib/auth';

/** M31 Поиск по смыслу по всем документам и расшифровкам с учётом прав доступа */
export function SmartSearchPage() {
  const { can } = useAuth();
  const qc = useQueryClient();
  const [q, setQ] = useState('');
  const [run, setRun] = useState('');
  const stats = useQuery({ queryKey: ['search-stats'], queryFn: () => api.get('/search/stats') });
  const res = useQuery({ queryKey: ['search', run], queryFn: () => api.get(`/search?q=${encodeURIComponent(run)}`), enabled: run.length > 1 });
  const reindex = useMutation({ mutationFn: () => api.post('/search/reindex'), onSuccess: () => qc.invalidateQueries({ queryKey: ['search-stats'] }) });
  const st = stats.data;
  return (
    <>
      <PageHeader title="Поиск по смыслу" subtitle={st ? `Проиндексировано документов: ${st.documents} из ${st.with_text} с текстом; фрагментов ${st.chunks}, с векторами ${st.vectors}` : undefined}
        actions={can('user.manage') && <Button variant="secondary" onClick={() => reindex.mutate()} disabled={reindex.isPending}>{reindex.isPending ? 'Индексирую...' : 'Обновить индекс'}</Button>} />
      <form className="card mb-4 flex gap-2 p-3" onSubmit={(e) => { e.preventDefault(); setRun(q.trim()); }}>
        <Input className="flex-1" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Например: отказ во включении требования из-за пропуска срока" autoFocus />
        <Button type="submit"><Search size={16} /> Найти</Button>
      </form>
      <ErrorText error={res.error ?? reindex.error} />
      {res.isFetching && <Spinner />}
      {res.data && (res.data.length ? <div className="space-y-3">{res.data.map((h: any) => (
        <div key={h.chunkId} className="card p-4">
          <div className="mb-1 flex flex-wrap items-center gap-2 text-sm"><Link to={`/documents?open=${h.documentId}`} className="font-medium text-brand-700 hover:underline">{h.title}</Link>
            {h.matterId && <Link to={`/matters/${h.matterId}`} className="text-xs text-slate-500 hover:underline">к делу</Link>}
            {h.via.map((v: string) => <Badge key={v} tone={v === 'смысл' ? 'blue' : 'slate'}>по {v === 'смысл' ? 'смыслу' : 'словам'}</Badge>)}</div>
          <div className="whitespace-pre-wrap text-sm text-slate-600">{h.text}</div>
        </div>))}</div> : <div className="card p-6 text-center text-sm text-slate-500">Ничего не найдено</div>)}
    </>
  );
}
